import createLucideIcon from '../createLucideIcon';

const Laugh = createLucideIcon('LaughIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z', key: 'b2q4dd' }],
  ['line', { x1: '9', y1: '9', x2: '9.01', y2: '9', key: '141aaf' }],
  ['line', { x1: '15', y1: '9', x2: '15.01', y2: '9', key: '1cyg3o' }],
]);

export default Laugh;
